module.exports = __webpack_public_path__ + "static/media/syez.f43146de.jpg";